import { render, staticRenderFns } from "./createEmpresa.vue?vue&type=template&id=53a9fb46&scoped=true&"
import script from "./createEmpresa.vue?vue&type=script&lang=js&"
export * from "./createEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./createEmpresa.vue?vue&type=style&index=0&id=53a9fb46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a9fb46",
  null
  
)

export default component.exports